export default __webpack_public_path__ + "static/media/plusIcon.bffe230f.svg";